import type { ExternalTableSchema } from '@packages/table-builder';
import { withTransferAllocateIdEndpoint } from '@apps/customer/pages/transfer-and-allocate/shared/transferAllocateEndpoint';
import {
  transferAllocateAllocatedListFilters,
  transferAllocateAllocatedListRequestParams,
} from '@apps/customer/pages/transfer-and-allocate/shared/transferAllocateAllocatedListDataSource';
import { transferIncludedItemColumns } from '@apps/customer/pages/transfer-and-allocate/shared/transferIncludedItemColumns';

export { withTransferAllocateIdEndpoint };

export const transferAllocateIncludedItemsTable: ExternalTableSchema = {
  metadata: {
    title: 'Included Transfer and Allocate items',
    entity: 'TransferAllocateIncludedItems',
  },
  dataSource: {
    endpoint: '/api/award/api/app/transfer-allocate/{id}/allocated-list',
    method: 'GET',
    rowIdField: 'id',
    requestParams: transferAllocateAllocatedListRequestParams,
    filters: transferAllocateAllocatedListFilters,
  },
  columns: transferIncludedItemColumns,
  computeRules: [
    {
      sourceFields: ['totalDesired', 'prior'],
      operator: 'subtract',
      targetField: 'incremental',
    },
  ],
  actions: {
    row: [
      { id: 'VIEW_DETAILS_TRANSFER_ALLOCATE_INCLUDED', label: 'View Details' },
      { id: 'REMOVE_TRANSFER_ALLOCATE_INCLUDED', label: 'Remove', variant: 'danger' },
    ],
    bulk: [{ id: 'REMOVE_BULK_TRANSFER_ALLOCATE_INCLUDED', label: 'Remove', variant: 'danger' }],
    toolbar: {
      secondary: [
        { id: 'VIEW_CLOSING_PRICE_TRANSFER_ALLOCATE', label: 'View Closing Price', variant: 'primary' },
      ],
    },
  },
  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'id', selectAllPages: true },
  },
};
